import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IGetUserIdentityMigrationProgressParams {
}

export interface GetUserIdentityMigrationProgressResult extends IResult {
    totalSystemUsers: number;
    totalSystemUsersWithConflicts: number;
    totalSystemUsersWithIdentities: number;
}

export class GetUserIdentityMigrationProgressRequest extends Request<IGetUserIdentityMigrationProgressParams, GetUserIdentityMigrationProgressResult> {
  constructor(params: IGetUserIdentityMigrationProgressParams = {}) {
    super('getUserIdentityMigrationProgress', params);
  }
}
